// src/components/Navigation.js
import React, { useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./Navigation.css"; // Import the CSS file
import {  AiOutlineFile, AiOutlineHome } from "react-icons/ai";
import { AiOutlineProfile } from "react-icons/ai";
import { AiOutlineShareAlt } from "react-icons/ai";
import { AiOutlineImport } from "react-icons/ai";
import { TiContacts } from "react-icons/ti"
import { setupInterceptors } from "../utilities/interceptor";

const Navigation = ({ showPremiumModal, setGlobalLoading }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const view = localStorage.getItem(document.location.hostname + '.view');

   useEffect(() => {
    setupInterceptors({
      getAuthToken: () => sessionStorage.getItem("JWAUTH"),
      handlers: {
        onPremiumRequired: (feature, url) => {
          showPremiumModal(feature,url);
        },

        onUnauthorized: () => {
          sessionStorage.removeItem("JWAUTH");
          navigate("/login", {
            state: { error: "You are not logged in." },
          });
        },

        onLoginFailed: () => {
          navigate("/login", {
            state: { error: "Login failed." },
          });
        },

        onRequestStart: () => setGlobalLoading(true),
        onRequestEnd: () => setGlobalLoading(false),
      },
    });
  }, []);

  return (
    <nav style={{ "background-color": "#000000", "color": "#fff" }}>
      <div class="max-w-screen-xl py-1 px-2 md:px-4 md:py-3 mx-auto grid grid-cols-1 justify-between items-center">
        {view === "S" ?<>
        <ul class="flex flex-row justify-stretch mt-0  rtl:space-x-reverse text-sm w-full	">
            <li className="w-full"><Link className="flex  justify-center items-center  rounded-t text-sm md:text-base hover:bg-555	hover:text-white " style={{ "background-color": pathname === "/" ? "#333" : "#000" }} to="/" >
              <AiOutlineHome className="inline-icon" />
            </Link></li>
            <li className="w-full "><Link className="flex  justify-center items-center rounded-t text-sm md:text-base hover:bg-555 hover:text-white " style={{ "background-color": pathname === "/spsharing" ? "#333" : "#000" }} to="/spsharing">
              <AiOutlineShareAlt className="inline-icon" />
            </Link></li>
            <li className="w-full "><Link className="flex justify-center items-center rounded-t text-sm md:text-base hover:bg-555 hover:text-white " style={{ "background-color": pathname === "/serviceProviders" ? "#333" : "#000" }} to="/serviceProviders">
              <AiOutlineProfile className="inline-icon" />
            </Link></li>
            <li className="w-full "><Link className="flex justify-center items-center rounded-t text-sm md:text-base hover:bg-555 hover:text-white " style={{ "background-color": pathname === "/serviceproviderrequests" ? "#333" : "#000" }} to="/serviceproviderrequests">
            <AiOutlineImport className="inline-icon" />
          </Link></li>
           {/*  <li className="w-full "><Link className="flex  justify-center items-center rounded-t text-sm md:text-base hover:bg-555 hover:text-white " style={{ "background-color": pathname === "/messages" ? "#333" : "#000" }} >
              <AiOutlineMessage className="inline-icon" />
            </Link></li> */}
          </ul>
        <ul class="flex flex-row justify-stretch mt-0 rtl:space-x-reverse text-sm w-full	">
        <li className="w-full"><Link className="flex justify-center items-center rounded-b text-sm md:text-base hover:bg-555 hover:underline-offset-1	hover:text-white " style={{ "background-color": pathname === "/" ? "#333" : "#000" }} to="/" >
          <span className="">Home</span>
        </Link></li>
        <li className="w-full "><Link className="flex   justify-center items-center rounded-b text-sm md:text-base hover:bg-555 hover:text-white hover:underline-offset-1 	" style={{ "background-color": pathname === "/spsharing" ? "#333" : "#000" }} to="/spsharing">
          <span className="">Shares</span>
        </Link></li>
        <li className="w-full "><Link className="flex justify-center items-center rounded-b text-sm md:text-base hover:bg-555 hover:text-white hover:underline-offset-1 " style={{ "background-color": pathname === "/serviceProviders" ? "#333" : "#000" }} to="/serviceProviders">
          <span className="">Services</span>
        </Link></li>
        <li className="w-full "><Link className="flex justify-center items-center rounded-b text-sm md:text-base hover:bg-555 hover:text-white hover:underline-offset-1 " style={{ "background-color": pathname === "/serviceproviderrequests" ? "#333" : "#000" }} to="/serviceproviderrequests">
            <span className="">Requests</span>
          </Link></li>
        {/* <li className="w-full "><Link className="flex justify-center items-center rounded-b text-sm md:text-base hover:bg-555 hover:text-white hover:underline-offset-1 " style={{ "background-color": pathname === "/messages" ? "#333" : "#000" }} >
          <span className="">Messages</span>
        </Link></li> */}
       
      </ul>
      </>
          :
          <>
          <ul class="flex flex-row justify-stretch mt-0 rtl:space-x-reverse text-sm w-full	">
          <li className="w-full"><Link className="flex justify-center items-center rounded-t text-sm md:text-base hover:bg-555	hover:text-white " style={{ "background-color": pathname === "/" ? "#333" : "#000" }} to="/" >
            <AiOutlineHome className="inline-icon" />
          </Link></li> 
          <li className="w-full "><Link className="flex justify-center items-center rounded-t text-sm md:text-base hover:bg-555 hover:text-white " style={{ "background-color": pathname === "/requests" ? "#333" : "#000" }} to="/requests">
            <AiOutlineImport className="inline-icon" />
          </Link></li>
          <li className="w-full "><Link className="flex justify-center items-center rounded-t text-sm md:text-base hover:bg-555 hover:text-white " style={{ "background-color": pathname === "/securedContents" ? "#333" : "#000" }} to="/securedContents">
            <AiOutlineProfile className="inline-icon" />
          </Link></li>
          <li className="w-full "><Link className="flex justify-center items-center rounded-t text-sm md:text-base hover:bg-555 hover:text-white " style={{ "background-color": pathname === "/documents" ? "#333" : "#000" }} to="/documents">
            <AiOutlineFile className="inline-icon" />
          </Link></li>
          <li className="w-full "><Link className="flex justify-center items-center rounded-t text-sm md:text-base hover:bg-555 hover:text-white " style={{ "background-color": pathname === "/sharing" ? "#333" : "#000" }} to="/sharing">
            <AiOutlineShareAlt className="inline-icon" />
          </Link></li>
          <li className="w-full "><Link className="flex justify-center items-center rounded-t text-sm md:text-base hover:bg-555 hover:text-white " style={{ "background-color": pathname === "/privateserviceproviders" ? "#333" : "#000" }} to="/privateserviceproviders" >
              <TiContacts className="inline-icon"/>
            </Link></li>
         

        </ul>
        <ul class="flex flex-row justify-stretch mt-0  rtl:space-x-reverse text-sm w-full	">
          <li className="w-full"><Link className="flex justify-center items-center rounded-b text-sm md:text-base hover:bg-555 hover:underline-offset-1	hover:text-white" style={{ "background-color": pathname === "/" ? "#333" : "#000" }} to="/" >
            <span className="">Home</span>
          </Link></li> 
          <li className="w-full "><Link className="flex justify-center items-center rounded-b text-sm md:text-base hover:bg-555 hover:text-white hover:underline-offset-1 " style={{ "background-color": pathname === "/requests" ? "#333" : "#000" }} to="/requests">
            <span className="">Requests</span>
          </Link></li>
          <li className="w-full "><Link className="flex justify-center items-center rounded-b text-sm md:text-base hover:bg-555 hover:text-white hover:underline-offset-1 " style={{ "background-color": pathname === "/securedContents" ? "#333" : "#000" }} to="/securedContents">
            <span className="">Content</span>
          </Link></li>
          <li className="w-full "><Link className="flex justify-center items-center rounded-b text-sm md:text-base hover:bg-555 hover:text-white hover:underline-offset-1 " style={{ "background-color": pathname === "/documents" ? "#333" : "#000" }} to="/documents">
            <span className="">Docs</span>
          </Link></li>
          <li className="w-full "><Link className="flex justify-center items-center rounded-b text-sm md:text-base hover:bg-555 hover:text-white hover:underline-offset-1 " style={{ "background-color": pathname === "/sharing" ? "#333" : "#000" }} to="/sharing">
            <span className="">Shares</span>
          </Link></li>

          <li className="w-full "><Link className="flex justify-center items-center rounded-b text-sm md:text-base hover:bg-555 hover:text-white hover:underline-offset-1 " style={{ "background-color": pathname === "/privateserviceproviders" ? "#333" : "#000" }} to="/privateserviceproviders" >
              <span className="text-center">Business Contacts</span>
            </Link></li>
          
        </ul>
        </>
        }
      </div>
    </nav>

  );
};

export default Navigation;
